const { billetStatus } = require('@transfeeradev/api-enums');

class BilletStatusService {
  static display(status) {
    if ([billetStatus.EXECUTING, billetStatus.EM_REMESSA, billetStatus.FAILED_INTERNAL].includes(status)) {
      return billetStatus.SCHEDULED;
    }

    return status;
  }
}

module.exports = BilletStatusService;
